import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import { media } from 'src/config/breakpoints';

export const UserCoursesHeaderContainer = styled.div`
  background: ${colors.grey05};
  margin: -1.0625rem -0.75rem 0;
  padding: 1.875rem 0.75rem 0;
  position: relative;

  ${media.w.min.px768(css`
    margin-bottom: 1.25rem;
    padding-top: 0.625rem;
  `)};

  ${media.w.min.px992(css`
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    margin-top: 0;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 3.125rem;
  `)};
`;
